import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-dep-confirmation',
  templateUrl: './dep-confirmation.component.html',
  styleUrls: ['./dep-confirmation.component.scss']
})
export class DepConfirmationComponent implements OnInit {

  title: string = this.data.title;
  message: string = this.data.message;
  noBtnText: string = this.data.noBtnText;
  yesBtnText: string = this.data.yesBtnText;

  constructor(
    public dialog: MatDialogRef<DepConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      noBtnText: string;
      yesBtnText: string;
    }
  ) { }

  ngOnInit() {
  }

  onCancel() {
    this.dialog.close(false);
  }

  onSubmit() {
    this.dialog.close(true);
  }
}
